import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Spinner } from 'shared-components/decorators/spinner';
import Reviews from '../../../api/api-reviews';
import { PaginationBtn } from '../elements-buttons/pagination-button';
import { Review } from './Review';

const REVIEWS_PER_PAGE = 10;

export const ReviewsOfYou = ({
  profile,
  accessToken,
  router,
  reviewsCache,
  setReviewsCache
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const currentPage = +router.location.query.page || 1;
  const displayedReviews = reviewsCache.reviews[currentPage] || [];

  const getReviews = async () => {
    const cachedReviews = reviewsCache.reviews[currentPage];
    if (cachedReviews) {
      setIsLoading(false);
      return;
    }

    const offset = REVIEWS_PER_PAGE * currentPage - REVIEWS_PER_PAGE;
    // only need BE to process total once
    const includeTotal = isNaN(reviewsCache.total);

    const res = await Reviews.getReviewsOfUser(
      accessToken,
      profile.SSOid,
      REVIEWS_PER_PAGE,
      offset,
      includeTotal
    );

    // BE response is different if total is included
    const total = !includeTotal ? reviewsCache.total : res.total_count;
    const reviews = !includeTotal ? res : res.reviews;
    setReviewsCache((prev) => ({
      total,
      reviews: {
        ...prev.reviews,
        [currentPage]: reviews
      }
    }));

    setIsLoading(false);
  };

  useEffect(() => {
    getReviews();
  }, [currentPage]);

  const goToPage = (page) => {
    setIsLoading(true);
    router.push({
      pathname: router.location.pathname,
      query: { page }
    });
  };

  return (
    <div className='padding-lg-top'>
      <h4 className='h4'>
        <FormattedMessage
          id='reviews.about_you_as_guest'
          defaultMessage='About you as a guest'
        />
        <span className='inline-block margin-md-left'>
          {!isNaN(+reviewsCache?.total) && `(${reviewsCache.total})`}
        </span>
      </h4>
      <p className='text-gray-600'>
        <FormattedMessage
          id='reviews.about_you_as_guest.description'
          defaultMessage='Reviews written about you as a guest'
        />
      </p>
      <div className='padding-lg-top'>
        {isLoading && (
          <div style={{ width: '50px' }}>
            <Spinner additionalStyle='gray' />
          </div>
        )}
        {!isLoading &&
          (!displayedReviews.length ? (
            <p className='text-gray-600'>
              <FormattedMessage
                id='reviews.about_you_as_guest.no_reviews'
                defaultMessage='No reviews have been written about you as a guest'
              />
            </p>
          ) : (
            <div>
              {displayedReviews.map((r) => (
                <div key={r._id} className='margin-xl-bottom'>
                  <Review review={r} />
                </div>
              ))}
              <PaginationBtn
                first={true}
                last={true}
                page={currentPage}
                paginate={({ eventKey }) => goToPage(eventKey)}
                limit={REVIEWS_PER_PAGE}
                pageCount={REVIEWS_PER_PAGE}
                totalCount={reviewsCache.total}
              />
            </div>
          ))}
      </div>
    </div>
  );
};
